import React, { useEffect, useMemo, useState } from 'react';
import './style.css';
import Cookies from 'universal-cookie';
import { Link, useLocation, useParams } from 'react-router-dom';
import LogoClube from '../../Assets/logoClube.svg';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ButtonLink from '../ButtonLink/ButtonLink';
import WhatsAppModal from '../WhatsAppModal';
import { useGlobal } from '../../GlobalContext';
import Loading from '../Loading';
import { resolveColor } from '../../Utills/colors';

const { REACT_APP_URL_API } = process.env;
const modalStyle = {
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--background)',
  border: '2px solid var(--title)',
  boxShadow: 24,
  p: 4,
};
const generateUUID = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

const Botaofacilities = () => {
  const { data, menu, loading } = useGlobal();
  const { cliente_id } = useParams();
  const location = useLocation();
  const [abrir1, setAbrir1] = useState(false);
  const [whatsappModalOpen, setWhatsappModalOpen] = useState(false);
  const [pendingWhatsAppUrl, setPendingWhatsAppUrl] = useState('');
  const apartamento = new URLSearchParams(location.search).get('x');
  const cookies = useMemo(() => new Cookies(), []);
  const [session] = useState(
    cookies.get('app_sessionid') || generateUUID(),
  );
  useEffect(() => {
    if (!cookies.get('app_sessionid'))
      cookies.set('app_sessionid', session, { path: '/' });
  }, [session, cookies]);
  localStorage.setItem('session', session);
  useEffect(() => {
    if (localStorage.getItem('ultrapassou_limite') === 'true')
      setTimeout(() => window.location.reload(), 1000);
  }, []);
  const processWhatsAppUrl = (btn, apelido, quarto, idioma) => {
    if (!btn.url) return null;
    if (!btn.url.includes('whatsapp')) return btn.url;
    const text = encodeURIComponent(
      `${apelido || 'Sem apelido'}, ${quarto || 'Sem identificação'} - iniciar atendimento - Idioma: ${idioma}`,
    );
    const match = btn.url.match(/whatsapp=(\d+)/);
    return match
      ? `https://wa.me/55${match[1]}?text=${text}`
      : `${btn.url}?text=${text}`;
  };
  const handleExternal = (event, url, isWhatsApp) => {
    event.preventDefault();
    if (!url) return;
    if (isWhatsApp) {
      setPendingWhatsAppUrl(url);
      setWhatsappModalOpen(true);
    } else window.open(url, '_blank', 'noopener,noreferrer');
  };

  {
    console.log('data', data);
  }
  if (loading || !menu)
    return (
      <div className="loading-container">
        <Loading />
      </div>
    );
  const cor1 = localStorage.getItem('cliente_cor_custom');
  const cor2 = localStorage.getItem('cliente_cor_custom2');
  const cor_letra = localStorage.getItem('cliente_cor_letra');
  const apelido = localStorage.getItem('cliente_apelido');
  const quarto = localStorage.getItem('cliente_apto') || apartamento;
  const frontNovo = localStorage.getItem('cliente_front_novo') === 'true';
  const mostraAds =
    localStorage.getItem('cliente_mostra_ads_primeira_pagina') === 'true';
  const idioma = navigator.language || navigator.userLanguage || 'pt-BR';
  const botoesAtivos = (data?.menu || [])
    .filter((btn) => !!btn.status)
    .sort((a, b) => a.ordem - b.ordem);
  const closeWhatsApp = () => {
    setWhatsappModalOpen(false);
    setPendingWhatsAppUrl('');
  };
  const renderButton = (btn, index) => {
    const isWhatsApp = btn.tipo === 'GE' && btn.url?.includes('whatsapp');
    const finalUrl =
      btn.tipo === 'GE'
        ? processWhatsAppUrl(btn, apelido, quarto, idioma)
        : btn.url;
    const path = {
      CA: `/${cliente_id}/cardapio/tipo/${location.search}`,
      DI: `/${cliente_id}/diretorio/${location.search}`,
      EX: `/${cliente_id}/extrato/${location.search}`,
      CO: `/${cliente_id}/concierge/${location.search}`,
    }[btn.tipo];
    if (frontNovo) {
      const content =
        btn.tipo === 'CV' ? <p>Clube de Vantagens</p> : <p>{btn.nome}</p>;
      const image =
        btn.tipo === 'CV'
          ? 'https://blog.viajarfazbem.com/wp-content/webp-express/webp-images/uploads/2019/02/original-60fa3fe0e7aae3a872c8222edeb6f18b.jpg.webp'
          : `${REACT_APP_URL_API}${btn.img}`;
      return (
        <div
          key={btn.id}
          className={`btn_facilities ${index % 3 === 0 ? 'full-width' : 'half-width'}`}
        >
          {path ? (
            <Link
              to={path}
              className="btn_facilities_link"
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)),url(${image})`,
              }}
            >
              {content}
            </Link>
          ) : (
            <a
              href={finalUrl || 'https://net4guest.com/'}
              target="_blank"
              rel="noopener noreferrer"
              onClick={
                btn.tipo === 'GE'
                  ? (event) => handleExternal(event, finalUrl, isWhatsApp)
                  : undefined
              }
              className="btn_facilities_link"
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)),url(${image})`,
                cursor: 'pointer',
              }}
            >
              {content}
            </a>
          )}
        </div>
      );
    }
    const background =
      btn.cor_1 === 'outra'
        ? btn.cor_custom || cor1
        : resolveColor(btn.cor_1, cor1 || '#3d489b');
    const content = (
      <>
        <img
          src={btn.tipo === 'CV' ? LogoClube : `${REACT_APP_URL_API}${btn.img}`}
          alt=""
        />
        <p style={{ color: cor_letra }}>
          {btn.tipo === 'CV' ? 'Clube de Vantagens' : btn.nome}
        </p>
      </>
    );
    return path ? (
      <Link
        key={btn.id}
        to={path}
        className="btn2_facilities"
        style={{ background, color: cor_letra }}
      >
        {content}
      </Link>
    ) : (
      <a
        key={btn.id}
        href={finalUrl || 'https://net4guest.com/'}
        target={btn.tipo === 'CV' ? '_blank' : undefined}
        rel={btn.tipo === 'CV' ? 'noopener noreferrer' : undefined}
        onClick={
          btn.tipo === 'GE'
            ? (event) => handleExternal(event, finalUrl, isWhatsApp)
            : undefined
        }
        className="btn2_facilities"
        style={{ background, color: cor_letra, cursor: 'pointer' }}
      >
        {content}
      </a>
    );
  };
  return (
    <>
      <div
        className={
          frontNovo ? 'container__btn_facilities' : 'container2__btn_facilities'
        }
      >
        {botoesAtivos.map(renderButton)}
      </div>
      <WhatsAppModal
        open={whatsappModalOpen}
        onClose={closeWhatsApp}
        onConfirm={() => {
          if (pendingWhatsAppUrl)
            window.open(pendingWhatsAppUrl, '_blank', 'noopener,noreferrer');
          closeWhatsApp();
        }}
      />
      {mostraAds && (
        <div className="div-ads">
          <ins
            className="adsbygoogle"
            style={{ display: 'inline-block', width: '100%', height: '100%' }}
            data-ad-client="ca-pub-3671789793368266"
            data-ad-slot="7389340169"
          />
        </div>
      )}
      <Modal
        open={abrir1}
        onClose={() => setAbrir1(false)}
        aria-labelledby="modal-modal-title"
      >
        <Box sx={modalStyle}>
          <div className="content_modal1">
            <p id="modal-modal-title">
              Não é possível acessar o Concierge. Ultrapassou o limite de acesso
              permitido.
            </p>
            <ButtonLink
              to={`/${cliente_id}`}
              text="Voltar"
              color={cor2 || 'var(--button_facilities)'}
            />
          </div>
        </Box>
      </Modal>
    </>
  );
};
export default Botaofacilities;
